const SkillB = () => {
  const skillList = {
    skills: [
      {
        title: "Javascript",
      },
      {
        title: "HTML",
      },
      {
        title: "CSS",
      },
    ],
  };
  const libList = {
    lib: [
      {
        title: "React",
      },
      {
        title: "Next.js",
      },
      {
        title: "Tailwindcss",
      },
      {
        title: "MUI",
      },
    ],
  };
  const toolList = {
    tool: [
      {
        title: "Github",
      },
      {
        title: "Slack",
      },
      {
        title: "Photoshop",
      },
    ],
  };

  return (
    <section id="skill" className="skill">
      <strong className="section_tit">
        <img src="/skill.png" alt="기술스택 아이콘" />
        <span>기술스택</span>
      </strong>
      <div className="lang mb-5 flex flex-col md:flex-row">
        <p className="text-lg w-64 mb-3 mb:mb-0">Language</p>
        <ul className="flex flex-wrap">
          {skillList.skills.map((skill, idx) => (
            <li key={idx} className="text-center mr-4 last-of-type:mr-0">
              <div>
                <p className="pt-mono inline-block bg-gray-700 py-1 px-2 rounded text-sky-300">
                  {skill.title}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="library mb-5 flex flex-col md:flex-row">
        <p className="text-lg w-64 mb-3 mb:mb-0">Framework / Library</p>
        <ul className="flex flex-wrap">
          {libList.lib.map((lib, idx) => (
            <li
              key={idx}
              className="text-center mr-4 mb-4 last-of-type:mr-0 md:mb-0"
            >
              <div>
                <p className="pt-mono inline-block bg-gray-700 py-1 px-2 rounded text-sky-300">
                  {lib.title}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="tool mb-5 flex flex-col md:flex-row">
        <p className="text-lg w-64 mb-3 mb:mb-0">Tool</p>
        <ul className="flex flex-wrap">
          {toolList.tool.map((tool, idx) => (
            <li key={idx} className="text-center mr-4 last-of-type:mr-0">
              <div>
                <p className="pt-mono inline-block bg-gray-700 py-1 px-2 rounded text-sky-300">
                  {tool.title}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default SkillB;
